export default __webpack_public_path__ + "static/media/whatWeDo.f96f2c2c.jpeg";